// src/components/erp/FormModal.jsx
import { Button, Dialog } from "../ui";

/**
 * Generic modal dialog for forms.
 * @param {Object} props
 * @param {boolean} props.open
 * @param {Function} props.onClose
 * @param {string} props.title
 * @param {React.ReactNode} props.children
 * @param {React.ReactNode} props.footer
 * @param {string} props.size  - "sm" | "md" | "lg" | "wide" | "xl"
 * @param {boolean} props.footerSticky - keep footer visible while body scrolls
 */
export default function FormModal({ open, onClose, title, children, footer, size = "md", disableBackdropClose = false }) {
  if (!open) return null;

  return (
    <Dialog
      open
      onOpenChange={(next) => { if (!next) onClose(); }}
      title={title}
      size={size}
      footer={footer}
      closeOnOutsideClick={!disableBackdropClose}
    >
      {children}
    </Dialog>
  );
}

/* ── Shared Button styles ──────────────────────────────── */

export function BtnPrimary({ children, disabled, ...props }) {
  return (
    <Button
      {...props}
      variant="primary"
      disabled={disabled}
      className="business-primary-action"
    >
      {children}
    </Button>
  );
}

export function BtnSecondary({ children, ...props }) {
  return (
    <Button
      {...props}
    >
      {children}
    </Button>
  );
}

export function BtnDanger({ children, disabled, ...props }) {
  return (
    <Button
      {...props}
      variant="danger"
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
